// Даты и счётные слова по-русски. Клиент показывает даты человеку, а не ISO:
// «5 сентября», «через 3 дня», «26 лет». Intl тут не используется намеренно —
// в Telegram-вебвью локаль браузера может быть любой, а падежи нужны наши.

const MONTHS_GEN = [
  'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
  'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря',
]

function parts(iso: string): { year: number; month: number; day: number } | null {
  const [year, month, day] = iso.split('-').map(Number)
  if (!year || !month || !day) return null
  return { year, month, day }
}

/** «5 сентября»; с годом — «5 сентября 2026». */
export function formatDate(iso: string, withYear = false): string {
  const value = parts(iso)
  if (!value) return iso
  const month = MONTHS_GEN[value.month - 1] ?? ''
  return `${value.day} ${month}${withYear ? ` ${value.year}` : ''}`
}

/** Интервал: «с 5 сентября по 17 сентября». Год добавляется, если он разный. */
export function formatRange(startIso: string, endIso: string): string {
  const start = parts(startIso)
  const end = parts(endIso)
  if (!start || !end) return `${startIso} — ${endIso}`
  const differentYears = start.year !== end.year
  return `с ${formatDate(startIso, differentYears)} по ${formatDate(endIso, differentYears)}`
}

/** Выбор формы по числу: plural(2, 'день', 'дня', 'дней'). */
export function plural(count: number, one: string, few: string, many: string): string {
  const abs = Math.abs(count) % 100
  const tail = abs % 10
  if (abs > 10 && abs < 20) return many
  if (tail > 1 && tail < 5) return few
  if (tail === 1) return one
  return many
}

/** «осталось 3 дня» / «последний день» / «сегодня переход». */
export function daysLeftLabel(days: number): string {
  if (days <= 0) return 'сегодня переход'
  if (days === 1) return 'остался 1 день'
  return `осталось ${days} ${plural(days, 'день', 'дня', 'дней')}`
}

/** «через 3 дня» — для списка переходов. */
export function inDaysLabel(days: number): string {
  if (days <= 0) return 'сегодня'
  if (days >= 700) {
    const years = Math.round(days / 365)
    return `через ${years} ${plural(years, 'год', 'года', 'лет')}`
  }
  if (days >= 60) {
    const months = Math.round(days / 30)
    return `через ${months} ${plural(months, 'месяц', 'месяца', 'месяцев')}`
  }
  return `через ${days} ${plural(days, 'день', 'дня', 'дней')}`
}

export function yearsLabel(years: number): string {
  return `${years} ${plural(years, 'год', 'года', 'лет')}`
}
